import { 
  signInWithPopup, 
  signOut, 
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword
} from 'firebase/auth';
import { auth, googleProvider } from '../firebase';
import axios from 'axios';

class FirebaseAuthService {
  // Google Sign In
  async signInWithGoogle(role = null, refCode = null) {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      // Get the ID token
      const idToken = await user.getIdToken();
      
      // Send to backend to create/update user
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/firebase`,
        {
          uid: user.uid,
          email: user.email,
          name: user.displayName,
          photoURL: user.photoURL,
          idToken: idToken,
          role: role,
          refCode: refCode
        }
      );
      
      return {
        user: response.data.user,
        token: response.data.token,
        isNewUser: response.data.isNewUser
      };
    } catch (error) {
      console.error('Google sign in error:', error);
      throw error;
    }
  }

  // Email/Password Sign In
  async signInWithEmail(email, password) {
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      const user = result.user;
      
      // Get the ID token
      const idToken = await user.getIdToken();
      
      // Send to backend
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/firebase`,
        {
          uid: user.uid,
          email: user.email,
          name: user.displayName,
          photoURL: user.photoURL,
          idToken: idToken
        }
      );
      
      return {
        user: response.data.user,
        token: response.data.token,
        isNewUser: response.data.isNewUser
      };
    } catch (error) {
      console.error('Email sign in error:', error);
      throw error;
    }
  }

  // Email/Password Sign Up
  async signUpWithEmail(email, password, name, role) {
    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
      const user = result.user;
      
      // Update the user's display name
      await user.updateProfile({
        displayName: name
      });
      
      // Get the ID token
      const idToken = await user.getIdToken();
      
      // Send to backend to create user
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/firebase`,
        {
          uid: user.uid,
          email: user.email,
          name: name,
          role: role,
          idToken: idToken
        }
      );
      
      return {
        user: response.data.user,
        token: response.data.token,
        isNewUser: response.data.isNewUser
      };
    } catch (error) {
      console.error('Email sign up error:', error);
      throw error;
    }
  }

  // Sign Out
  async signOut() {
    try {
      await signOut(auth);
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    } catch (error) {
      console.error('Sign out error:', error);
      throw error;
    }
  }

  // Get current user
  getCurrentUser() {
    return auth.currentUser;
  }

  // Listen to auth state changes
  onAuthStateChanged(callback) {
    return onAuthStateChanged(auth, callback);
  }
}

const firebaseAuthService = new FirebaseAuthService();
export default firebaseAuthService;
